/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_VotedInputs */

const en_us2_board_voted = /** @type {(inputs: Board_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported`)
};

const pt_br2_board_voted = /** @type {(inputs: Board_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiado`)
};

const pt_pt2_board_voted = /** @type {(inputs: Board_VotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoiado`)
};

/** @type {(inputs: Board_VotedInputs) => LocalizedString} */
const es_419_board_voted = en_us2_board_voted;

/** @type {(inputs: Board_VotedInputs) => LocalizedString} */
const fr_fr2_board_voted = en_us2_board_voted;

/** @type {(inputs: Board_VotedInputs) => LocalizedString} */
const de_de2_board_voted = en_us2_board_voted;

/** @type {(inputs: Board_VotedInputs) => LocalizedString} */
const it_it2_board_voted = en_us2_board_voted;

/**
* | output |
* | --- |
* | "Supported" |
*
* @param {Board_VotedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_voted = /** @type {((inputs?: Board_VotedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_VotedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_voted(inputs)
	if (locale === "es-419") return es_419_board_voted(inputs)
	if (locale === "pt-PT") return pt_pt2_board_voted(inputs)
	if (locale === "fr-FR") return fr_fr2_board_voted(inputs)
	if (locale === "de-DE") return de_de2_board_voted(inputs)
	if (locale === "it-IT") return it_it2_board_voted(inputs)
	return en_us2_board_voted(inputs)
});
export { board_voted as "board.voted" }